export default __webpack_public_path__ + "static/media/hand-with-chocolate.93f94c3e.png";